// @ts-check
import DueDateSelector from './DueDateSelector';
import { StyledFilterSetForm, StyledHeader } from './FilterSetForm.style';
import NameSelector from './NameSelector';
import TypeSelector from './TypeSelector';
import useFormState from './useFormState';
import VisibilitySelector from './VisibilitySelector';
import useFormSaveHandler from './useFormSaveHandler';
import useFormValidator from './useFormValidator.js';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { LBButton } from '@linearb/buzz';

const FilterSetForm = ({ filterSet, Context, onSubmit, onBack }) => {
  const {
    formState,
    onInputChange,
    onDueDateChange,
    onTypeChange,
    onVisibilityChange
  } = useFormState({
    filterSet,
    Context
  });
  const formValidator = useFormValidator({ Context, formState });

  const formSaveHandler = useFormSaveHandler({
    formState,
    Context,
    onSubmit,
    formValidator
  });

  return (
    <StyledFilterSetForm data-cy='filter-set-form'>
      <StyledHeader>Save Filters</StyledHeader>
      <NameSelector
        formState={formState}
        onChange={onInputChange}
        validator={formValidator}
      />
      <TypeSelector
        value={formState?.type}
        onChange={onTypeChange}
        validator={formValidator}
      />
      {formState.type === SAVED_FILTER_SET_TYPES.PROJECT && (
        <DueDateSelector
          value={formState.due_date}
          onChange={onDueDateChange}
          validator={formValidator}
        />
      )}
      {/* Tmporary in comment until we support PDT creation */}
      {/* {formState.type === SAVED_FILTER_SET_TYPES.PROJECT && (
        <ProjectDelivery
          projectCadence={formState.cadence}
          // onCadenceChange={onCadenceChange}
          // onPdtChecked={onPdtChecked}
          isPdtChecked={formState.is_pdt}
        />
      )} */}
      <VisibilitySelector
        value={formState.visibility}
        onChange={onVisibilityChange}
        validator={formValidator}
      />
      <div className='mt-4 flex flex-row justify-end gap-2'>
        {onBack && (
          <LBButton variant='outline' onClick={() => onBack?.()}>
            Cancel
          </LBButton>
        )}
        <LBButton
          onClick={formSaveHandler.submit}
          disabled={formSaveHandler.isLoading || !formValidator.isValid}
          data-cy='filter-set-form-save-button'
        >
          Save
        </LBButton>
      </div>
    </StyledFilterSetForm>
  );
};

export default FilterSetForm;
